import DarkLightToggleSwitch from "./DarkLightToggleSwitch";

export default DarkLightToggleSwitch;
